var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modalTextEditor",
      attrs: { id: "modalTextEditor", title: _vm.title, size: "xl" },
      on: { ok: _vm.updateNotes, shown: _vm.setInitialFocus },
    },
    [
      _vm._l(_vm.messages, function (message) {
        return _c(
          "b-alert",
          {
            key: message.text,
            attrs: {
              show: message.countdown || true,
              fade: "",
              dismissible: "",
              variant: message.variant || "danger",
            },
          },
          [_vm._v(_vm._s(message.text))]
        )
      }),
      _vm._v(" "),
      _c("b-alert", { attrs: { variant: "warning", show: !_vm.canUpdate } }, [
        _vm._v(
          "You do not have access to update notes, so this view is read only!"
        ),
      ]),
      _vm._v(" "),
      _c("b-alert", { attrs: { variant: "info", show: _vm.canUpdate } }, [
        _vm._v(
          "Hint: Drag and Drop note lines to re-order. Hit enter while editing a line to add a blank one beneath it. Hit backspace or delete in an empty line to delete it."
        ),
      ]),
      _vm._v(" "),
      _vm.canUpdate
        ? _c(
            "b-button-toolbar",
            { staticClass: "pb-1" },
            [
              _c(
                "b-button-group",
                { staticClass: "mx-1 mb-1 mb-md-0", attrs: { size: "md" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.addLine()
                        },
                      },
                    },
                    [_vm._v("Add New")]
                  ),
                  _vm._v(" "),
                  _vm.orderedLines.length
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "danger" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteLine()
                            },
                          },
                        },
                        [_vm._v("Delete All")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "draggable",
            {
              staticClass: "form-row",
              attrs: { draggable: ".app-web-text-line" },
              on: { end: _vm.dragLineToPosition },
              model: {
                value: _vm.orderedLines,
                callback: function ($$v) {
                  _vm.orderedLines = $$v
                },
                expression: "orderedLines",
              },
            },
            _vm._l(_vm.orderedLines, function (line, lineIndex) {
              return _c(
                "div",
                {
                  key: lineIndex,
                  staticClass: "col-sm-12 app-web-text-line pb-1",
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c(
                        "span",
                        { staticClass: "input-group-text text-right" },
                        [_vm._v(_vm._s(_vm.formatLineNumber(lineIndex + 1)))]
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.canUpdate
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: line.text,
                              expression: "line.text",
                            },
                          ],
                          ref: "lines",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            maxlength: "64",
                            readonly: "",
                          },
                          domProps: { value: line.text },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(line, "text", $event.target.value)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canUpdate
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: line.text,
                              expression: "line.text",
                            },
                          ],
                          ref: "lines",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: { type: "text", maxlength: "64" },
                          domProps: { value: line.text },
                          on: {
                            paste: function ($event) {
                              return _vm.pasteContent(line, $event)
                            },
                            keyup: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.addLine(line)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "delete",
                                    [8, 46],
                                    $event.key,
                                    ["Backspace", "Delete", "Del"]
                                  )
                                )
                                  return null
                                if (!$event.ctrlKey) return null
                                return _vm.deleteLine(line)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "delete",
                                    [8, 46],
                                    $event.key,
                                    ["Backspace", "Delete", "Del"]
                                  )
                                )
                                  return null
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                return _vm.deleteEmptyLine(line)
                              },
                            ],
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "delete",
                                    [8, 46],
                                    $event.key,
                                    ["Backspace", "Delete", "Del"]
                                  )
                                )
                                  return null
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                return _vm.checkForEmptyLine(line)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k($event.keyCode, "up", 38, $event.key, [
                                    "Up",
                                    "ArrowUp",
                                  ])
                                )
                                  return null
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                return _vm.moveFocusToLine(
                                  line,
                                  false,
                                  true,
                                  $event
                                )
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "down",
                                    40,
                                    $event.key,
                                    ["Down", "ArrowDown"]
                                  )
                                )
                                  return null
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                return _vm.moveFocusToLine(
                                  line,
                                  false,
                                  false,
                                  $event
                                )
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k($event.keyCode, "up", 38, $event.key, [
                                    "Up",
                                    "ArrowUp",
                                  ])
                                )
                                  return null
                                if (
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                if (!$event.ctrlKey) return null
                                return _vm.moveFocusToLine(
                                  line,
                                  true,
                                  true,
                                  $event
                                )
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "down",
                                    40,
                                    $event.key,
                                    ["Down", "ArrowDown"]
                                  )
                                )
                                  return null
                                if (
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                if (!$event.ctrlKey) return null
                                return _vm.moveFocusToLine(
                                  line,
                                  true,
                                  false,
                                  $event
                                )
                              },
                            ],
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(line, "text", $event.target.value)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }